import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TeamworkIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Teamwork",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "5.714",
      cy: "5.714",
      r: "3.429"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "26.286",
      cy: "5.714",
      r: "3.429"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "5.714",
      cy: "26.286",
      r: "3.429"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "26.286",
      cy: "26.286",
      r: "3.429"
    }), /*#__PURE__*/_jsx("path", {
      d: "M30.857 14.857c-7.563 0-13.715-6.152-13.715-13.714a1.143 1.143 0 1 0-2.285 0c0 7.562-6.152 13.714-13.714 13.714a1.143 1.143 0 0 0 0 2.286c7.562 0 13.714 6.152 13.714 13.714a1.143 1.143 0 1 0 2.285 0c0-7.562 6.152-13.714 13.715-13.714a1.143 1.143 0 0 0 0-2.286M16 24.954A16.07 16.07 0 0 0 7.048 16 16.07 16.07 0 0 0 16 7.047 16.07 16.07 0 0 0 24.952 16 16.07 16.07 0 0 0 16 24.954"
    })]
  }));
};
TeamworkIcon.displayName = 'TeamworkIcon';